import keycloakService from '../../keycloak_service';

import { postToSinatra } from '../api_utils';

export const fetchModelStorageSize = (queryParams) => {
  const [, model_id, workspace_id] = queryParams;
  const body = JSON.stringify({ model_id, workspace_id, confirm_delete: false });

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToSinatra('v1/api/models/delete_model', fetchOptions)
}

export const removeModel = (model_id, workspace_id) => {
  const body = JSON.stringify({ model_id, workspace_id, confirm_delete: true })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToSinatra('v1/api/models/delete_model', fetchOptions).catch(() => {
    throw new Error('Error')
  })
}

export default removeModel;
